export default __webpack_public_path__ + "static/media/food-and-drink.72e65612.svg";